{
  "version": 1,
  "asset_id": "2b31ac97-90ea-4bf0-8594-31c46bfe2ec3",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/2b31ac97-90ea-4bf0-8594-31c46bfe2ec3/opt_metodo-2.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/2b31ac97-90ea-4bf0-8594-31c46bfe2ec3/opt_metodo-2.jpg",
  "original_filename": "opt_metodo-2.jpg",
  "size": 118121,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:24Z"
}
